import { Logger } from 'aws-amplify';
import Vue from 'vue';
import store from '@/store';
import EventBus from '@/EventBus';

const logger = new Logger('EventHandler');

// Player events
const STORY_CHANGED = 'storyChanged';
const GROUP_CHANGED = 'groupChanged';
const SCENE_CHANGED = 'sceneChanged';
const ORIENTATION_CHANGED = 'orientationChanged';
const FOV_CHANGED = 'fovChanged';
const PLAYER_READY = 'playerReady';
const SCENE_LOAD_ERROR = 'sceneLoadError';
const SCENE_LOAD_START = 'sceneLoadStart';
const SCENE_LOAD_PROGRESS = 'sceneLoadProgress';
const LONG_PRESS = 'longpress';
const CLICK = 'click';
const ERROR = 'error';
const HOTSPOT_CLICKED = 'hotspotClicked';
const HOTSPOT_OVER = 'hotspotOver';
const HOTSPOT_OUT = 'hotspotOut';
const HOTSPOT_ADDED = 'hotspotAdded';
const PLAYER_ONPAUSE = 'onPause';
const PLAYER_ONPLAY = 'onPlay';
const PLAYER_ONDURATION_CHANGE = 'onDurationChange';
const PLAYER_ONTIME_UPDATE = 'onTimeUpdate';
const PLAYER_ONCANPLAY = 'onCanPlay';
const PLAYER_ONLOADEDMETADATA = 'onLoadedMetaData';
const PLAYER_ONLOADEDDATA = 'onLoadedData';
const PLAYER_LOOP_ENABLED = 'loopEnabled';
const PLAYER_MUTED = 'muted';
const PLAYER_ONVOLUME_CHANGE = 'onVolumeChange';
const PLAYER_WEBGL_LOST = 'webGLcontextLost';
const PLAYER_RANDOM_EVENT = 'randomEvent';
const PLAYER_WEBGL_RESTORED = 'webGLcontextRestored';
// const PLAYER_VIDEO_QUALITIES = 'qualities';
const PLAYER_CREATE_ERROR = 'playerCreateError';
// const PLAYER_QUALITIES_LOADED = 'qualitiesLoaded';
const PLAYER_QUALITY_CHANGE = 'qualityChange';
const PLAYER_QUALITY_REQUEST = 'qualityRequest';
const PLAYER_QUALITY_MODE = 'qualityModeChange';
const PLAYER_DELETED = 'playerDeleted';
const PLAYER_CLEARED = 'playerCleared';

const messageHandler = (msg) => {
  const obj = msg.data;

  if (obj.id === '360share') {
    if (obj.event !== 'onTimeUpdate') logger.debug(obj.event);

    let hs;

    switch (obj.event) {
      case PLAYER_MUTED:
        store.commit('muted', obj.data);
        break;
      case PLAYER_LOOP_ENABLED:
        store.commit('loopEnabled', obj.data);
        break;
      case PLAYER_ONTIME_UPDATE:
        store.commit('currentTime', obj.data);
        break;
      case PLAYER_ONDURATION_CHANGE:
        store.commit('duration', obj.data);
        break;
      case PLAYER_ONPAUSE:
        store.commit('playState', 0);
        store.commit('appState', 'PAUSED');
        break;
      case PLAYER_ONPLAY:
        store.commit('playState', 1);
        store.commit('playbackStarted', true);
        break;
      case PLAYER_ONCANPLAY:
        store.commit('appState', 'CANPLAY');
        break;
      case PLAYER_ONLOADEDMETADATA:
        break;
      case PLAYER_ONLOADEDDATA:
        break;
      case PLAYER_ONVOLUME_CHANGE:
        store.commit('volume', obj.data);
        store.commit('muted', obj.data === 0);
        break;
      case STORY_CHANGED:
        logger.debug(obj.data);
        break;
      case GROUP_CHANGED:
        logger.debug(obj.data);
        break;
      case SCENE_CHANGED:
        logger.debug(obj.data);
        break;
      case ORIENTATION_CHANGED:
        logger.debug(`yaw:${obj.data.yaw} pitch:${obj.data.pitch}`);
        break;
      case FOV_CHANGED:
        break;
      case PLAYER_READY:
        store.commit('playerReady', true);
        break;
      case SCENE_LOAD_START:
        break;
      case SCENE_LOAD_ERROR:
        break;
      case SCENE_LOAD_PROGRESS:
        break;
      case LONG_PRESS:
        break;
      case CLICK:
        break;
      case ERROR:
        logger.error(`${obj.data}`);
        break;
      case HOTSPOT_CLICKED:
        if (store.state.project.content === 'video') Vue.prototype.$player.pause();
        hs = store.state.hotspots[obj.data];
        if (hs.hotspotType === 3) {
          if (hs.actionURL.includes('http://') || hs.actionURL.includes('https://')) {
            window.open(hs.actionURL, `eSiteExternal${obj.data}`);
          } else {
            window.open(`https://${hs.actionURL}`, `eSiteExternal${obj.data}`);
          }
        } else {
          store.commit('customText', hs.customText);
          store.commit('hotspotDescription', hs.hotspotDescription);
          store.commit('currentHotspot', hs);
        }
        break;
      case HOTSPOT_OVER:
        break;
      case HOTSPOT_OUT:
        break;
      case HOTSPOT_ADDED:
        break;
      case PLAYER_RANDOM_EVENT:
        logger.debug(`randomEvent:${obj}`);
        break;
      case PLAYER_WEBGL_LOST:
        EventBus.$emit('reader-dialog', {
          refresh: true,
          type: 'error',
          title: 'WebGL problem',
          text: 'Browser has lost WebGL ability. Please close all other running applications and try to refresh page.',
        });
        break;
      case PLAYER_WEBGL_RESTORED:
        EventBus.$emit('reader-dialog', { hide: true });
        break;
      case PLAYER_CREATE_ERROR:
        logger.error(obj.data);
        break;
      case PLAYER_QUALITY_CHANGE:
        logger.debug(obj.data);
        break;
      case PLAYER_QUALITY_REQUEST:
        logger.debug(obj.data);
        break;
      case PLAYER_QUALITY_MODE:
        logger.debug(obj.data);
        break;
      case PLAYER_CLEARED:
        logger.debug('playerCleared');
        store.commit('playState', 0);
        store.commit('appState', 'LOADING');
        Vue.prototype.$player.reCreate();
        break;
      case PLAYER_DELETED:
        break;
      default:
    }
  }
};

window.addEventListener('message', messageHandler, false);
